import { Component, Input } from '@angular/core';
import { CardHeader } from '../../main/models/cardHeader';
@Component({
  selector: 'anms-card-column-header',
  templateUrl: './cardColumnHeader.component.html',
  styleUrls: ['./cardColumnHeader.component.scss'],
  standalone: false
})
export class CardColumnHeaderComponent {
  @Input() public cardHeaders: CardHeader[] = [];
}
